<template>
  <div class="d-flex">
    <div class="col-md-11 col-lg-11">

      <div class="sale-details-section" ref="saleLinesTable" style="box-shadow: 0 -4px 0px rgba(0, 0, 0, 0.2);">
        <div class="shopping-cart" ref="shoppingCart">
          <ul class="list-group list-group-flush mt-2 lists" style="height: 43vh">
            <li class="list-group-item p-0 d-flex align-items-center justify-content-between" :key="index"
              v-for="(sale, index) in currentSaleLines" :class="{
                'new-item': isLineNew(sale, index),
                'updated-item': isLineUpdated(sale, index),
                'old-item': !isLineNew(sale, index) && !isLineUpdated(sale, index)
              }">
              <input type="checkbox" :checked="selectedLine === index" @change="setLine(index)" />
              <NewCurrentSaleLine @click="setLine(index)" :sale-line="sale" :is-new-item="isLineNew(sale, index)"
                :is-updated-item="isLineUpdated(sale, index)" :ref="el => setLineRef(el, index)"
                style="margin-left: 5px" />
            </li>
          </ul>
        </div>
      </div>

      <div v-if="this.$store.getters.getOpenTableName" class="alert alert-info p-2">
        Open Table: {{ this.$store.getters.getOpenTableName }}
      </div>
      <SaleDetails class="sales" />
    </div>
    <div class="col-md-1 col-lg-2">
      <div class="scroll-controls">
        <button class="scroll-control d-block" @click="previousSelectedLine">
          <font-awesome-icon :icon="['fas', 'chevron-up']" />
        </button>
        <button class="scroll-control d-block" @click="nextSelectedLine">
          <font-awesome-icon :icon="['fas', 'chevron-down']" />
        </button>
        <button class="scroll-control d-block" @click="addToCart">
          <font-awesome-icon :icon="['fas', 'plus']" />
        </button>
        <button class="scroll-control d-block" @click="removeFromCart">
          <font-awesome-icon :icon="['fas', 'minus']" />
        </button>
        <button class="scroll-control d-block" @click="removeItem">
          <font-awesome-icon :icon="['fas', 'trash']" />
        </button>
        <!--        <button class="scroll-control d-block" @click="searchBar">-->
        <!--          <font-awesome-icon :icon="['fas', 'search']" />-->
        <!--        </button>-->
        <button class="scroll-control d-block" @click="showDiscount">
          <font-awesome-icon :icon="['fas', 'percent']" />
        </button>
        <button class="scroll-control d-block" @click="qty">
          <font-awesome-icon :icon="['fas', 'sort-amount-up']" />
        </button>

        <button class="scroll-control d-block" @click="showPopover" ref="popoverTopBtn">
          <font-awesome-icon icon="info-circle" />
        </button>
        <div class="info-popover-container">
          <div ref="popoverTop" class="popover-content" :class="{ 'popover-visible': isPopoverVisible }"
            style="width: 250px">
            <div class="popover-inner">
              <button @click.stop.prevent="hidePopover" style="margin-left: 32vh; height: 1vh; width: 1vh"
                class="btn-close"></button>
              <div class="d-flex gap-2 p-2">
                <div>
                  <button class="scroll-control" @click="syncData">
                    <font-awesome-icon :icon="['fas', 'arrows-rotate']" />
                  </button>
                  <label>Refresh</label>
                </div>
                <div v-if="customer">
                  <button class="scroll-control" @click="unselectCustomer">
                    <font-awesome-icon :icon="['fas', 'user-minus']" />
                  </button>
                  <label>Remove Customer</label>
                </div>
                <div v-else>
                  <button class="scroll-control" @click="selectCustomer">
                    <font-awesome-icon :icon="['fas', 'user-plus']" />
                  </button>
                  <label>Add Customer</label>
                </div>
                <div v-if="$store.getters.getZedMobileStatus">
                  <div class="scroll-control">
                    <a class="btn fw-bold text-primary" data-bs-toggle="modal"
                      data-bs-target="#exampleModal"><font-awesome-icon :icon="['fas', 'receipt']" /></a>
                  </div>
                  <label>Zed Mobile</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Voucher Purchasing Screen</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body" style="max-height: 75vh; overflow-y: auto;">
            <div class="row">
              <!-- Left side: existing design -->
              <div class="col-md-4">
                <div class="list-group">
                  <a class="list-group-item list-group-item-action" v-for="(option, index) in options" :key="index"
                    @click="selectOption(option)">
                    {{ option }}
                  </a>
                </div>
              </div>
              <!-- Right side: list of other clickable options -->
              <div class="col-md-8">
                <div class="product-card" v-for="item in selectedItem" :key="item.PLU" @click="checkItemOffer(item)">
                  <div class="stock-card_img mx-2 mt-2" v-if="item.Image">
                    <img :src="item.Image" alt="Item Image">
                  </div>
                  <div class="card-body mx-3 p-1 d-flex justify-content-between flex-column">
                    <span class="text-secondary text-sm">Stock Code : {{ item.PLU }}</span>
                    <h6 class="product-description">
                      {{ item.Description }} <br>
                      <span class="product-description2">{{ item.Description2 }}</span>
                    </h6>
                    <h5 class="product-price">{{ $utils.formatMoney(item.SellingIncl) }}</h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" id="closebutton" data-bs-dismiss="modal">Close</button>
          </div>
        </div>
      </div>
    </div>
    <!--        modal ends for voucher-->
  </div>
</template>

<script>
import { createPopper } from '@popperjs/core';
import SaleDetails from "@/components/point-of-sale/sales/SaleDetails.vue";
import NewCurrentSaleLine from "@/components/point-of-sale/sales/NewCurrentSaleLine.vue";
import { Storage } from "@/services/Storage";
import store from "@/store";

export default {
  name: "ShoppingChart",
  components: { NewCurrentSaleLine, SaleDetails },
  computed: {
    options() {
      return this.$store.getters.getZedMobileCategories;
    },
    customer() {
      let id = this.$store.getters.getCustomer;
      return this.$store.getters.getDebtorByID(id);
    },
    currentSaleLines() {
      return this.$store.getters.getSaleLines
    },
  },
  data() {
    return {
      isPopoverVisible: false,
      selectedLine: null,
      lineRefs: {},
      initialLineCount: 0,
      originalLines: [],
      selectedItem: [],
    }
  },
  watch: {
    currentSaleLines(newLines, oldLines) {
      // Reset the count if the newLines array is refreshed
      if (newLines.length !== oldLines.length) {
        this.setInitialLineCount();
      }
    }
  },
  created() {
    // Set initial line count when the component is created
    this.setInitialLineCount();
  },
  methods: {
    checkItemOffer(item) {
      this.currentItem = item; // Track the selected item
      const hasOffer = item.offer;

      if (hasOffer) {
        this.triggerModal('openAmountInputModalButton');
      } else {
        this.triggerModal('openCustomerInformationModalButton');
      }
    },
    triggerModal(buttonId) {
      const button = document.getElementById(buttonId);
      if (button) {
        button.click();
      }
    },
    selectOption(option) {
      this.$utils.showLoading();
      this.selectedCategory = option;
      return axios.get(zedMobileApi + 'products/getByCatgeory', {
        params: { category: option },
        headers: { "Api-key": this.$store.getters.getZedMobileApiKey }
      }).then(response => this.selectedItem = response.data)
        .catch(error => errorHandler.tomcatError(error))
        .finally(() => this.$utils.hideLoading());
    },
    selectCustomer() {
      return this.$router.push({ name: `select-customer`, query: { saleNumber: this.$route.query.saleNumber } })
    },
    unselectCustomer() {
      this.$store.commit(`setCustomer`, '')
    },
    showPopover(event) {
      this.$emit('hide-all-popovers');
      if (this.isPopoverVisible) {
        this.hidePopover();
        return;
      }
      this.isPopoverVisible = true;
      this.createPopperInstance();
    },
    hidePopover() {
      this.isPopoverVisible = false;
    },
    createPopperInstance() {
      if (this.popperInstance) {
        this.popperInstance.destroy();
      }

      this.popperInstance = createPopper(this.$refs.popoverTopBtn, this.$refs.popoverTop, {
        placement: 'right',
        modifiers: [
          {
            name: 'offset',
            options: {
              offset: [0, 8], // 8 pixels from the trigger element
            },
          },
          {
            name: 'preventOverflow',
            options: {
              padding: 8,
            },
          },
        ],
      });
    },
    qty() {
      if (this.selectedLine !== null) {
        return Swal.fire({
          title: 'Set Quantity',
          icon: 'question',
          input: 'text',
          showCancelButton: true,
          confirmButtonText: 'Submit',
          showLoaderOnConfirm: true,
          allowOutsideClick: false,
          inputValidator: async (input) => {
            if (!input || isNaN(input) || input <= 0) {
              return 'Please enter a valid number greater than 0';
            }
            this.lineRefs[this.selectedLine].saleLine.Qty = Number(input);
            await this.$store.dispatch(`recalculateVat`)
            this.$store.dispatch(`calculateTipAmount`)
            localStorage.setItem('currentSaleLines', JSON.stringify(this.$store.getters.getSaleLines));
          },
        });
      } else {
        responses.showWarning('No line selected');
        console.warn('No line selected');
      }
    },
    isLineNew(saleLine, index) {
      // Check if the line is added after the initial table load
      return index >= this.initialLineCount;
    },
    isLineUpdated(saleLine, index) {
      if (index >= this.originalLines.length) return false;

      const originalLine = this.originalLines[index];
      return this.hasLineChanged(originalLine, saleLine);
    },
    hasLineChanged(originalLine, currentLine) {
      // Define what constitutes a change
      const keysToCompare = [
        'Qty',
        'Unit',
        'Discount',
        'Line',
        'instructions'
      ];

      return keysToCompare.some(key => {
        if (key === 'instructions') {
          return JSON.stringify(originalLine.instructions) !== JSON.stringify(currentLine.instructions);
        }
        return originalLine[key] !== currentLine[key];
      });
    },
    setInitialLineCount() {
      if (this.initialLineCount === 0) {
        this.initialLineCount = this.currentSaleLines.length;
        this.originalLines = JSON.parse(JSON.stringify(this.currentSaleLines));
      }
    },
    syncData() {
      return window.location.reload(true);
    },
    setLine(index) {
      // If clicking the same line again, deselect it
      if (this.selectedLine === index) {
        this.selectedLine = null;
      } else {
        // Select the new line
        this.selectedLine = index;
      }
    },
    process() {
      return this.$router.push({ name: 'payment' })
    },
    askForPrice(item) {
      this.$store.commit('setIsTabOpen', true)
      return Swal.fire({
        allowOutsideClick: false,
        showCancelButton: true,
        showLoaderOnConfirm: true,
        title: `Set Selling Price`,
        html: `<h6 >Description : ${item.Description}</h6>
               <h6 >Current Price : ${$utils.formatMoney(item.SellingIncl)}</h6>
               <input type="number" step="0.01" id="selling-prc" class="swal2-input" placeholder="Selling Price" style="max-width: 70%">`,
        confirmButtonText: 'Set Price',
        focusConfirm: false,
        preConfirm: async () => {
          let value = Swal.getPopup().querySelector('#selling-prc').value;
          if (!value) {
            Swal.showValidationMessage(`Please enter a valid Selling Price`)
          }
          return parseFloat(value);
        }
      }).then(result => {
        this.$store.commit('setIsTabOpen', false)
        if (result.isConfirmed) {
          return result.value;
        }
        return parseFloat(item.SellingIncl.toFixed(2))
      })
    },
    askForDescription(item) {
      this.$store.commit('setIsTabOpen', true)
      return Swal.fire({
        allowOutsideClick: false,
        showCancelButton: true,
        showLoaderOnConfirm: true,
        title: `Set Description`,
        html: `<h6 >Description : ${item.Description}</h6>
               <textarea id="desc-ask" class="swal2-input" placeholder="Description" style="max-width: 70%">`,
        confirmButtonText: 'Set Description',
        focusConfirm: false,
        preConfirm: async () => {
          let value = Swal.getPopup().querySelector('#desc-ask').value
          if (!value || value.toString().trim() === "") {
            Swal.showValidationMessage(`Please enter a valid Description`)
          }
          return value;
        }
      }).then(result => {
        this.$store.commit('setIsTabOpen', false)
        if (result.isConfirmed) {
          return result.value;
        }
        return item.Description
      })
    },
    previousSelectedLine() {
      if (this.selectedLine !== null) {
        if (this.selectedLine > 0) {
          this.selectedLine--;
        } else {
          this.selectedLine = this.currentSaleLines.length - 1;  // Wrap around to the last item
        }
      } else {
        responses.showWarning('No line selected')
        console.warn("No line selected");
      }
    },
    nextSelectedLine() {
      if (this.selectedLine !== null) {
        if (this.selectedLine < this.currentSaleLines.length - 1) {
          this.selectedLine++;
        } else {
          this.selectedLine = 0;  // Wrap around to the first item
        }
      } else {
        responses.showWarning('No line selected')
        console.warn("No line selected");
      }
    },
    removeFromCart() {
      if (this.selectedLine !== null) {
        this.$store.commit(`setOverrideDetails`, `Void Item (${this.currentSaleLines[this.selectedLine].Description})`)
        return this.$store.commit("voidItem", this.currentSaleLines[this.selectedLine]);
      } else {
        responses.showWarning('No line selected')
        console.warn("No line selected");
      }
    },
    addToCart() {
      if (this.selectedLine !== null) {
        const plu = this.currentSaleLines[this.selectedLine].Plu;
        return this.$store.dispatch('getStockSetting', plu)
          .then(async (set) => {
            let askForPrice = false;
            let cookingLink = 0;
            if (set) {
              askForPrice = set.askForPrice;
              cookingLink = set.cookingLink;
            }
            let price = Number(this.currentSaleLines[this.selectedLine].Unit.toFixed(2));
            let description = this.currentSaleLines[this.selectedLine].Description;

            if (askForPrice) {
              price = (await this.askForPrice(this.currentSaleLines[this.selectedLine]));
            }
            if (cookingLink) {
              return this.$router.push({
                name: 'instruction',
                query: {
                  plu: this.currentSaleLines[this.selectedLine].Plu
                }
              })
            }

            let specialPrice = this.$store.getters.getItemSpecialPrice(this.currentSaleLines[this.selectedLine].Plu)
            if (specialPrice) {
              price = specialPrice;
            }

            let tourismLevy = 0.0;
            if (set.tourism) {
              let obj = { amount: price, incl: true }
              tourismLevy = await this.$store.dispatch('getTourismLevyAmount', obj);
            }
            let obj = {
              Plu: this.currentSaleLines[this.selectedLine].Plu,
              Description: description,
              Qty: 1,
              Unit: price,
              Line: price,
              tourismLevy,
              Discount: 0,
              vat: 0,
              instructions: []
            }
            this.$store.commit('addToCurrentSaleLines', obj)
            return this.recalculateTip();
          })
      } else {
        responses.showWarning('No line selected')
        console.warn("No line selected");
      }
    },
    recalculateTip() {
      return this.$store.dispatch('calculateTipAmount')
    },
    setLineRef(el, index) {
      // Dynamic ref setting
      if (el) {
        this.lineRefs[index] = el;
      }
    },
    showDiscount() {
      if (this.selectedLine !== null) {
        const selectedLineComponent = this.lineRefs[this.selectedLine];

        if (selectedLineComponent && selectedLineComponent.discount) {
          selectedLineComponent.discount();
        } else {
          console.error("Discount method not found for the selected line.");
        }
      } else {
        responses.showWarning('No line selected')
        console.warn("No line selected");
      }
    },
    async removeItem() {
      if (this.selectedLine !== null) {
        const selectedLineComponent = this.lineRefs[this.selectedLine];
        if (selectedLineComponent && selectedLineComponent.voidItem) {
          const item = this.currentSaleLines[this.selectedLine];
          selectedLineComponent.voidItem(item);
        } else {
          console.error("void method not found for the selected line.");
        }
      } else {
        responses.showWarning('No line selected')
        console.warn("No line selected");
      }
    }
  },


}
</script>

<style lang="scss" scoped>
.info-popover-container {
  position: relative;
  z-index: 1000; // Ensure info button is above other elements
}

.info-icon {
  margin-left: 8px;
  font-size: 0.7rem;
}

.popover-content {
  position: absolute;
  visibility: hidden;

  background-color: white;
  border: 1px solid #e5e7eb;
  border-radius: 0.5rem;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);

  //width: 10rem;
  padding: 0.5rem;
}

.popover-visible {
  visibility: visible;
}

.popover-inner {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  z-index: 2;
}

.scroll-control {
  margin-bottom: 2px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: rgba(59, 130, 246, 0.2);
  color: #3b82f6;
}

.sales {
  width: 28%;
  position: absolute !important;
  bottom: 5px !important;
}

.lists {
  cursor: pointer;
  position: relative;
  max-height: 400px;
  /* Set a fixed max height for the scrolling area */
  overflow-y: auto;
  /* Allow vertical scrolling */
  overflow-x: hidden;
  padding-right: 10px;
  /* Optional: Add some space for scrollbar */
}

/* For new items: green background */
/* For new items: green background */
.new-item {
  background-color: rgba(0, 255, 0, 0.2);
  /* Light green */
}

/* For updated items: yellow background */
.updated-item {
  background-color: rgba(255, 223, 0, 0.3);
  /* Light yellow */
}

/* For old items: no background */
.old-item {
  background-color: transparent;
}

.updated-item {
  background-color: rgba(255, 223, 0, 0.3);
  /* Light yellow */
}


#shopping-cart-panel {
  display: flex !important;
  flex-direction: column;
  border-left: 1px solid #eee;
  padding: 0;
  position: relative;

  .scroll-controls {
    //position: absolute;
    bottom: 0 !important;
    right: 0 !important;
    display: flex;
    flex-direction: column;
    gap: 10px;

    .scroll-control {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      background: #0092f7;
      color: white;
    }
  }

  #customer-panel {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 10px;
    height: 60px;
    border-bottom: 1px solid #eee;
    padding-bottom: 5px;

    .select-customer-btn {
      width: 60px;
      height: 60px;
      border-radius: 50%;
      color: #303030;
      font-size: 22px;
    }
  }

  .sale-details-section {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    overflow-y: auto;

    .shopping-cart {
      flex: 1 1 auto;
      overflow-y: auto;
      overflow-x: hidden;
    }

    .sales-stats {
      flex: 0 1 auto;
      height: 85px;
      border-top: 1px solid #eee;
      padding-top: 5px;
      position: absolute !important;
      bottom: 5px !important;

      .cart-actions {
        .btn {
          border-radius: 0;
          color: #ffffff;
          font-weight: 600;
          border: none;

          &.btn-primary {
            background: #3496F0;
          }

          &.btn-secondary {
            background: #C6C6C6;
            //color: #585858;
          }

          &.btn-dark {
            background: #2D2D2D;
          }
        }
      }
    }
  }
}

.sales-panel {
  display: flex;
  flex-direction: column;
  padding: 0;
  position: relative;

  .sale-header {
    background: #F2F2F4;
    box-shadow: 0 2px 8px 0 rgba(203, 153, 126, 0.4);
    border: 1px solid #E6E7EC;
    height: 53px;
    max-height: 55px;

    .header {
      display: flex;
      flex-direction: row;
      align-items: center;

      h2 {
        margin: 0;
      }

      button {
        width: 30px;
        background: white;
        font-size: 25px;
      }
    }
  }

  @media (min-height: 769px) {
    .sale-lines-table {
      height: 83vh !important;
    }
  }

  .sale-lines-table {
    flex: auto;
    overflow-y: auto;
    height: 77vh;

    .sales-list {
      list-style: none;
      padding: 0 0 130px 0;

      li {
        border: 1px solid #E6E7EC;
      }
    }
  }

  .sale-stats {
    position: absolute;
    background: #F2F2F4;
    border: 1px solid #E6E7EC;
    max-height: 163px;
    bottom: 0;
    left: 0;
    right: 0;
  }
}

.list-group-item {
  font-size: 1.5rem;
  /* Increased font size */
  padding: 15px 20px;
  /* Increased padding */
}

h4,
h5,
h6 {
  margin: 0;
}

.example-card-img-responsive {
  width: 80px;
  height: 65px;
  margin: 10px;
  opacity: 0.8;
}

.product-card {
  height: 110px;
  transition: 200ms ease-in-out;
  overflow: hidden;
  width: 100%;
  background-color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 0.25rem;
  display: flex;
  flex-direction: row;
  word-wrap: break-word;

  .product-description {
    font-weight: 600;
    color: #303030;
  }

  .product-description2 {
    font-weight: 400;
    color: #303030;
  }

  .product-price {
    font-weight: 700;
    color: #322f2f;
  }

  &:hover,
  &:focus {
    background: #0092f7;
    color: white;
    transform: scale(1.03);

    .product-description {
      color: white;
    }

    .product-price {
      color: white;
    }
  }
}

img {
  height: 94px;
  width: 94px;
  opacity: 0.7;
  border-radius: 10px;
}

.text-sm {
  font-size: 12px !important;
}
</style>